import { PropsWithChildren } from "react"

export function Container({ children }: PropsWithChildren<{}>) {
  return (
    <main className="flex h-full w-full justify-center px-4 pb-6 pt-4 md:pt-14">
      <div className="relative flex h-full w-full max-w-screen-lg flex-col justify-between gap-y-4 md:gap-y-6">
        {children}
      </div>
    </main>
  )
}
